import React from "react";
import { Spinner } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import Loading from "../../../Components/Loading";
import { ToTimeJalali } from "../../../Utils/functions";
import { useChat } from "../Hooks/support";

const Chat = () => {
  const { messagesEndRef, chat, loading, send, handler, form, navigate } =
    useChat();
  return (
    <div className="chat">
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">صفحه پشتیبانی</p>
        </div>
      </header>
      <div className="chat-body">
        {loading.get ? (
          <div className="m-2">
            <Loading count={12} height={40} />
          </div>
        ) : (
          <div>
            {chat.messages.map(message => {
              if (message.type == "question") {
                return (
                  <div className="d-flex  question mb-2">
                    <div className="flex-1">
                      <div className="w-xxl-75">
                        <div className="hover-actions-trigger d-flex align-items-center">
                          <div className="chat-message bg-200  rounded-2">
                            {message.message}
                          </div>
                        </div>
                        <div className="text-400 fs--2 mt-1">
                          <span>{ToTimeJalali(message.created_at)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className="w-100 w-xxl-75 answer mb-2">
                    <div className="hover-actions-trigger d-flex flex-end-center">
                      <div className=" rounded-2 chat-message light">
                        {message.message}
                      </div>
                    </div>
                    <div className="text-400 fs--2 text-end mt-1">
                      <span>{ToTimeJalali(message.created_at)}</span>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
      <div className="chat-send-message">
        <textarea
          onChange={({ target: { value } }) => {
            handler("message", value);
          }}
          value={form.message}
          rows={2}
          placeholder="متن پیام ..."
        ></textarea>
        <button onClick={send}>
          {loading.send ? <Spinner size="sm" /> : "ارسال"}
        </button>
      </div>
    </div>
  );
};

export default Chat;
